module.exports = __webpack_public_path__ + "img/d200902-2.97b49067.jpg";